/* eslint-disable no-unused-vars */
import React, { useCallback } from 'react';
import { Tags } from 'store/types';
import style from './searchButton.module.scss';
import Button from 'controls/buttons/submit';
import SearchIcon from 'icons/search';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { isEmpty } from 'lodash-es';
import map from 'lodash-es/map';
import { useCurrentCategory } from 'hooks/useCategoryId';
import { useRegisterKeyHandler } from 'hooks/useKeyHandler';

export default function SearchButton({
  selected,
  setIsOpen,
  isOpen,
  baseURL = '/search',
  keyHandlerId,
}: {
  selected: Tags;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
  isOpen: boolean;
  baseURL?: string;
  keyHandlerId: string;
}) {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const currentCategory = useCurrentCategory();
  const isDisabled = isEmpty(selected);

  const clickHandler = useCallback(() => {
    setIsOpen(false);

    const ids = map(selected, (tag) => tag.name);
    searchParams.set('tags', ids.join(','));
    searchParams.set('category', currentCategory.id);
    searchParams.delete('page');
    navigate(`${baseURL}?${searchParams.toString()}`, {
      replace: false,
    });
  }, [selected, currentCategory.id, baseURL, searchParams]);

  const keyHandler = useCallback(
    (e: KeyboardEvent) => {
      if (isOpen || isDisabled) {
        return;
      }

      switch (e.code) {
        case 'Enter':
          e.preventDefault();
          e.stopPropagation();
          clickHandler();
          break;
      }
    },
    [isOpen, clickHandler]
  );
  useRegisterKeyHandler({
    handler: keyHandler,
    id: keyHandlerId,
  });

  return (
    <Button
      disabled={isDisabled}
      wrapper={{
        className: style.buttonWrapper,
      }}
      className={style.button}
      endIcon={<SearchIcon></SearchIcon>}
      onClick={clickHandler}
    ></Button>
  );
}
